import Lottie from 'react-lottie'
import * as animatedPennyLaneLogo from '../../images/animated-pennylane.json'
import './LoaderPennyLane.scss'

const LoaderPennyLane = ({
  height = 100,
  width = 100,
  isFullPage = false,
  text = '',
}: {
  height?: number
  width?: number
  isFullPage?: boolean
  text?: string
}) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animatedPennyLaneLogo,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  return (
    <div
      className={`LoaderPennyLane ${
        isFullPage ? 'LoaderPennyLane--fullPage' : ''
      }`}
    >
      <div className="LoaderPennyLane__logo">
        <Lottie options={defaultOptions} height={height} width={width} />
        {text && <p className="text-center mt-4">{text}</p>}
      </div>
    </div>
  )
}

export default LoaderPennyLane
